<template lang="pug">
.bloco-dados-territorio-monitoramento-agricola
    .bloco-dados-territorio--interno
        .bloco-dados-territorio--interno--texto
            .bloco-dados-territorio-interno--titulo {{ $t('mensagens.comuns.monitoramento.localidade') }}
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.territorio.localidade }}
        .bloco-dados-territorio--interno--texto
            .bloco-dados-territorio-interno--titulo {{ $t('mensagens.comuns.produtor') }}
                span(
                    v-if='monitoramento.territorio.representantes && monitoramento.territorio.representantes.length > 1'
                )
                    el-popover(placement='right', trigger='hover')
                        el-tag.ml-2(
                            v-if='monitoramento.territorio.representantes.length > 1',
                            size='mini',
                            slot='reference'
                        ) {{ monitoramento.territorio.representantes.length - 1 }}

                        .lista-scroll
                            div(
                                v-for='(representante, index) in monitoramento.territorio.representantes',
                                :key='index'
                            ) {{ representante.nomeRazaoSocial }}
                    .bloco-dados-territorio-interno--valor {{ monitoramento.territorio.representantes[0].nomeRazaoSocial }}

                .bloco-dados-territorio-interno--valor(
                    v-else-if='monitoramento.territorio.representantes && monitoramento.territorio.representantes.length === 0'
                )
                    span -

                .bloco-dados-territorio-interno--valor(v-else)
                    span(
                        v-for='(representante, index) in monitoramento.territorio.representantes',
                        :key='index'
                    ) {{ representante.nomeRazaoSocial }}

        .bloco-dados-territorio--interno--texto
            .bloco-dados-territorio-interno--titulo {{ $t('mensagens.monitoramentoAgricola.dataEnvioParaMonitoramento') }}
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.dataAtualizacaoFormatado !== '-' ? monitoramento.dataAtualizacaoFormatado : monitoramento.dataCadastroFormatado }}

        .bloco-dados-territorio--interno--texto
            .bloco-dados-territorio-interno--titulo {{ $t('mensagens.monitoramentoAgricola.dataDeEncerramento') }}
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.dataFimFormatado }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'BlocoDadosTerritorioMonitoramentoAgricolaParaguai',
    props: {
        monitoramento: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    },
    data() {
        return {};
    },
    methods: {
        formatarCar(codigo) {
            if (!codigo) return '-';
            return codigo.replace(codigo.substring(7, 31), '...');
        },
        getArea(territorio) {
            return `${formatters.formatNumber(territorio.areaHa, 2)} ha`;
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-dados-territorio-monitoramento-agricola {
    height: 80px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);

    .bloco-dados-territorio-interno--titulo {
        padding-top: 0px;
        font-size: 14px;
        font-weight: 600;

        flex-wrap: wrap;
        padding-right: 5rem;
        margin-top: 7px;
    }

    .bloco-dados-territorio--interno {
        display: flex;
        flex-direction: row;
        width: 100%;

        .bloco-dados-territorio--interno--texto {
            flex-wrap: wrap;
            display: flex;
            flex-direction: row;
            min-height: 104px;
            margin-left: 12px;
            width: 45%;
            justify-content: center;

            span {
                margin-top: 6px;
            }
        }
    }

    .bloco-dados-territorio-interno--valor {
        display: flex;
        flex-direction: column;
        padding-top: 1px;
        margin-bottom: 5%;
        max-width: 22rem;

        font-weight: 400;
        color: var(--primary);
        font-size: 12px;
    }

    & p:first-child {
        margin: 4px 3px 8px 0px;
    }

    & p:not(:first-child) {
        margin: 2px 3px 8px 0px;
    }
}
@media only screen and (max-width: 1340px) {
    .bloco-dados-territorio-monitoramento-agricola {
        min-width: 48% !important;
    }
}
</style>
